// extracted by mini-css-extract-plugin
export default {"logo_color":"qYUW9","logo":"qIiB_","logo_short":"DeF8V"};